import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import ctaBg from "@/assets/home-cta-efh-pv-2.webp";
gsap.registerPlugin(ScrollTrigger);

export default function CTASection() {
  const sectionRef = useRef<HTMLElement>(null);
  const titleRef = useRef<HTMLDivElement>(null);
  const bodyRef = useRef<HTMLDivElement>(null);
  const btnRef = useRef<HTMLAnchorElement>(null);
  const glowRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const section = sectionRef.current;
    const title = titleRef.current;
    const body = bodyRef.current;
    const btn = btnRef.current;
    if (!section || !title || !body || !btn) return;

    const titleLines = title.querySelectorAll("[data-line]");

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: "top 75%",
        toggleActions: "play none none none",
      },
    });

    tl.fromTo(
      titleLines,
      { y: 60, opacity: 0 },
      { y: 0, opacity: 1, duration: 1, stagger: 0.1, ease: "power3.out" }
    );

    tl.fromTo(
      body,
      { y: 30, opacity: 0 },
      { y: 0, opacity: 1, duration: 0.8, ease: "power3.out" },
      "-=0.5"
    );

    tl.fromTo(
      btn,
      { y: 20, opacity: 0, scale: 0.95 },
      { y: 0, opacity: 1, scale: 1, duration: 0.6, ease: "power3.out" },
      "-=0.4"
    );

    return () => {
      tl.scrollTrigger?.kill();
      tl.kill();
    };
  }, []);

  useEffect(() => {
    // Hover-Glow entfernt
  }, []);

  return (
    <section
      ref={sectionRef}
      className="relative overflow-hidden rounded-[40px] py-24 md:py-32 lg:py-36 px-6 md:px-10 lg:px-14"
      style={{
        backgroundImage: `url(${ctaBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Dunkles Overlay für Lesbarkeit */}
      <div className="absolute inset-0 bg-black/45 pointer-events-none" />



      
      
      <div className="relative z-10 max-w-3xl mx-auto">
        <div
          className="p-6 sm:p-8 md:p-10 lg:p-12 rounded-2xl backdrop-blur-[16px] border border-[#4CAF50]/25 text-center"
          style={{ backgroundColor: "rgba(13,31,18,0.45)" }}
        >
          <div ref={titleRef}>
            <h2 className="font-heading font-bold uppercase text-[26px] sm:text-[36px] md:text-[52px] lg:text-[72px] text-white tracking-tight leading-[0.95]">
              <span data-line className="block overflow-hidden">
                <span className="block">Bereit für Ihre</span>
              </span>
              <span data-line className="block overflow-hidden">
                <span className="block text-accent-500">eigene Energie?</span>
              </span>
            </h2>
          </div>
          <div ref={bodyRef} className="mt-8 text-white/80 text-base md:text-lg max-w-xl mx-auto leading-relaxed">
            Lassen Sie uns über Ihr Projekt sprechen — kostenlos und unverbindlich. Am Niederrhein zuhause.
          </div>
          <a
            ref={btnRef}
            href="/kontakt"
            className="inline-flex items-center mt-8 px-8 py-4 rounded-full bg-accent-500 text-white text-sm font-medium hover:bg-accent-600 transition-colors"
          >
            Kostenlose Erstberatung
          </a>
        </div>
      </div>
    </section>
  );
}